// extracted by mini-css-extract-plugin
export default {"container":"SubHeader_container__k0wpm","content":"SubHeader_content__O0FLw"};